module.exports = ["area","base","basefont","bgsound","br","col","command","embed","frame","hr","image","img","input","isindex","keygen","link","menuitem","meta","nextid","param","source","track","wbr"]


//////////////////
// WEBPACK FOOTER
// ../node_modules/html-void-elements/index.json
// module id = 983
// module chunks = 0